import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import { factoryJobPostKey } from '../factories/queries';

export const useGenerateJobDescription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (postingId: string) => PermanentJobsService.generateJobDescription(postingId),
    onSuccess: (_, postingId) => {
      queryClient.invalidateQueries({ queryKey: factoryJobPostKey(postingId) });
    },
  });
};
